<div class="p-2 is-flex is-flex-direction-column scroll-panel is-gap-1">
  <h3>{{ 'tarificateur.summary.offer' | translate }}</h3>
  <div>
    <h4>{{ 'tarificateur.summary.beneficiaries' | translate }}</h4>
    @if ($beneficiariesSummary().length > 0) {
      <div>
        @for (beneficiary of $beneficiariesSummary(); track $index) {
          @if ($index === 0) {
            <div class="is-flex is-justify-content-space-between">
              <p>{{ beneficiary.first_name }} {{ beneficiary.last_name }}</p>
              <p>{{ beneficiary.birth_date | date: 'dd/MM/yyyy' }}</p>
            </div>
          } @else {
            <div class="is-flex is-justify-content-space-between">
              <p>
                {{
                  (beneficiary.category === 'Enfant'
                    ? 'relation.children'
                    : beneficiary.category === 'Conjoint'
                      ? 'relation.spouse'
                      : beneficiary.category === 'Souscripteur'
                        ? 'relation.subscriber'
                        : beneficiary.category) | translate
                }}
              </p>
              <p>{{ beneficiary.birth_date | date: 'dd/MM/yyyy' }}</p>
            </div>
          }
        }
      </div>
    }
  </div>
  <div>
    <h4>{{ 'nationality.subscriber' | translate }}</h4>
    <p>{{ $nationalitySubscriber() }}</p>
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.resum.expatriation' | translate }}</h4>
    <p>{{ $expatCountry() }}</p>
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'recap.duration' | translate }}</h4>
    <p>{{ 'tarificateur.resum.year' | translate }}</p>
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.resum.contractstart' | translate }}</h4>
    <p>{{ pricingInfos.effect_date | date: 'dd/MM/yyyy' }}</p>
  </div>
  <div class="is-flex is-justify-content-center">
    <button mat-stroked-button [routerLink]="'/project'" (click)="dissmiss()">
      {{ 'modify.information' | translate }}
    </button>
  </div>
  <h3>{{ 'tarificateur.coverage.and.options' | translate }}</h3>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.resum.currency' | translate }}</h4>
    <p [innerHTML]=" 'tarificateur.currency.' + pricingInfos.currency+'_recap'| translate"></p>
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.hospitalisation' | translate }}</h4>
    <div class="is-flex is-flex-direction-column">
      <p>{{ pricingInfos.expat_project_plan }}</p>
      <p>{{ 'tarificateur.resum.reimbursement' | translate }}</p>
      <p>{{ plan | currencyFormat }}</p>
    </div>
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.medicalcare' | translate }}</h4>
    @if (+pricingInfos.expat_project_medical_care_option! === 0) {
      <p>{{ 'tarificateur.option.selected' | translate }}</p>
    } @else {
      <p>
        {{ 'tarificateur.level' | translate }}
        {{ pricingInfos.expat_project_medical_care_option }}
      </p>
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.dental' | translate }}</h4>
    @if (+pricingInfos.expat_project_dental_and_optical_option! === 0) {
      <p>{{ 'tarificateur.option.selected' | translate }}</p>
    } @else {
      <p>
        {{ 'tarificateur.level' | translate }}
        {{ pricingInfos.expat_project_dental_and_optical_option }}
      </p>
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.maternity' | translate }}</h4>
    @if (+pricingInfos.expat_project_maternity_option! === 0) {
      <p>{{ 'tarificateur.option.selected' | translate }}</p>
    } @else {
      <p>
        {{ 'tarificateur.level' | translate }}
        {{ pricingInfos.expat_project_maternity_option }}
      </p>
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.assistanceplus' | translate }}</h4>
    @if (+pricingInfos.expat_project_assistance_plus_option! === 1) {
      <p>{{ 'key.yes' | translate }}</p>
    } @else {
      <p>{{ 'key.no' | translate }}</p>
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.franchise' | translate }}</h4>
    @if (+pricingInfos.expat_project_deductible === 0) {
      <p>{{ 'tarificateur.withoutfranchise' | translate }}</p>
    } @else {
      <p>{{ pricingInfos.expat_project_deductible | currencyFormat }}</p>
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.payement.frequency' | translate }}</h4>
    @switch (pricingInfos.expat_project_periodicity_choice) {
      @case (1) {
        <p>{{ 'tarificateur.payement.frequency.yearly' | translate }}</p>
      }
      @case (2) {
        <p>{{ 'tarificateur.payement.frequency.sixmonths' | translate }}</p>
      }
      @case (3) {
        <p>{{ 'tarificateur.payement.frequency.threemonths' | translate }}</p>
      }
      @case (4) {
        <p>{{ 'tarificateur.payement.frequency.monthly' | translate }}</p>
      }
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4 class="is-flex is-flex-direction-column">
      <span>{{ 'tarificateur.area.coverage' | translate }}</span>
      <span>{{ 'tarificateur.coverage.subtitle' | translate }}</span>
    </h4>
    <p>
      {{ $coverageZone() }}
    </p>
  </div>
  <div class="is-flex is-flex-direction-column">
    <h4>{{ 'tarificateur.coverage.country' | translate }}</h4>
    @if (+pricingInfos.expat_project_additional_country! !== 0) {
      <p>{{ $secondExpatCountry() | async }}</p>
    } @else {
      <p>{{ 'tarificateur.aucun' | translate }}</p>
    }
  </div>
  <div class="is-flex is-flex-direction-column">
    @if ($expatPricing().already_covered_in_origin_country === 'Oui') {
      <h4>{{ 'subscription.already.covered' | translate }}</h4>
    } @else if ($expatPricing().already_covered_in_origin_country === 'non_applicable') {
      <h4>
        {{ 'subscription.cover.impossible' | translate }}
      </h4>
    } @else {
      <h4>
        {{ 'tarificateur.couverturenationalite' | translate }}
      </h4>
      @if (pricingInfos.expat_project_cover_nationality_country === 'Non') {
        <p>{{ 'key.no' | translate }}</p>
      } @else if (pricingInfos.expat_project_cover_nationality_country === 'Oui') {
        <p>{{ 'key.yes' | translate }}</p>
      } @else {
        <p>{{ 'subscription.cover.impossible' | translate }}</p>
      }
    }
  </div>
</div>
<div class="fixed-bottom is-hidden-tablet">
  <mat-divider class="mb-4"></mat-divider>
  <div class="is-flex is-align-items-center gap-s pb-3">
    <div class="amount is-flex is-flex-direction-column is-align-items-center">
      <span class="is-size-5 has-text-weight-bold">
        {{ $price().price | currencyFormat }}
      </span>
      <span class="is-size-7">{{ $price().frequency | translate }}</span>
    </div>
    <div class="has-text-weight-semibold">
      {{ 'tarificateur.custom.offer' | translate }}
    </div>
    <button mat-icon-button (click)="dissmiss()">
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
</div>
